export default "__VITE_ASSET__CVEhEO6X__"